import styled from 'styled-components'

const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${({ theme }) => theme.fonts.goodOT};
  font-size: 16px;
  line-height: 1.2;
  font-weight: 600;
`

export default ItemHeader
